"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
require("./Tag.css");
var Tag = /** @class */ (function (_super) {
    __extends(Tag, _super);
    function Tag(props) {
        var _this = _super.call(this, props) || this;
        _this._customizeClass = function (colorEnum, type) {
            var lowerEnum = colorEnum.toLowerCase();
            var types = {
                'hoverbg': "p-bg-hv-" + lowerEnum,
                'background': "p-bg-" + lowerEnum,
                'border': "p-bc-" + lowerEnum,
                'hoverbc': "p-bc-hv-" + lowerEnum,
                'text': "p-t-" + lowerEnum
            };
            // Data Colors need the 50. Greys/White Do not. 
            return types[type].indexOf('grey') > -1 ||
                types[type].indexOf('white') > -1 ?
                types[type] : types[type] + '50';
        };
        _this._onClick = _this._onClick.bind(_this);
        return _this;
    }
    Tag.prototype._onClick = function () {
        this.props.onClick && this.props.onClick(this.props.value);
    };
    Tag.prototype._getProps = function () {
        var _a = this.props, tag = _a.tag, text = _a.text, closeTitle = _a.closeTitle, isCloseable = _a.isCloseable, style = _a.style, customColor = _a.customColor, backgroundColor = _a.backgroundColor, truncate = _a.truncate;
        /* istanbul ignore next */
        var color = this.props.color || 'Grey50';
        var tagClass = ['p-tag'];
        var dotClass = ['p-tag-dot'];
        var closeClass = ['p-tag-close', 'p-icon-cross'];
        var tagStyle = {};
        var dotStyle = {};
        var closeStyle = {};
        /* istanbul ignore else */
        if (style === 'Filled') {
            tagClass.push('p-t-light');
            closeClass.push('p-t-light');
            if (!customColor) {
                tagClass.push(this._customizeClass(color, 'background'));
                tagClass.push(this._customizeClass(color, 'border'));
                tagClass.push(this._customizeClass(color, 'hoverbg'));
                tagClass.push(this._customizeClass(color, 'hoverbc'));
            }
            else {
                Object.assign(tagStyle, {
                    backgroundColor: customColor,
                    borderColor: customColor
                });
                tagClass.push(this._customizeClass('Grey60', 'hoverbg'));
                tagClass.push(this._customizeClass('Grey60', 'hoverbc'));
            }
        }
        else if (style === 'Outline') {
            if (!customColor) {
                var textColor = this._customizeClass(color, 'text');
                closeClass.push(textColor);
                tagClass.push(textColor);
                tagClass.push(this._customizeClass(color, 'border'));
                tagClass.push(this._customizeClass(color, 'hoverbc'));
            }
            else {
                Object.assign(closeStyle, {
                    color: customColor
                });
                Object.assign(tagStyle, {
                    color: customColor,
                    borderColor: customColor,
                });
                tagClass.push(this._customizeClass('Grey60', 'hoverbc'));
            }
            if (backgroundColor) {
                tagClass.push(this._customizeClass(backgroundColor, 'background'));
            }
        }
        else if (style === 'Dot') {
            tagClass.push(this._customizeClass('Grey60', 'border'));
            tagClass.push(this._customizeClass('Primary', 'hoverbc'));
            tagClass.push('p-t-meta');
            closeClass.push('p-t-meta');
            if (!customColor) {
                dotClass.push(this._customizeClass(color, 'background'));
            }
            else {
                Object.assign(dotStyle, {
                    backgroundColor: customColor
                });
            }
            if (backgroundColor) {
                tagClass.push(this._customizeClass(backgroundColor, 'background'));
            }
        }
        isCloseable && tagClass.push('is-closeable');
        truncate && tagClass.push('truncate');
        return {
            tagProps: {
                className: tagClass.join(' '),
                style: tagStyle,
                title: text,
                'data-tag': tag
            },
            dotProps: {
                className: dotClass.join(' '),
                style: dotStyle
            },
            closeProps: {
                className: closeClass.join(' '),
                style: closeStyle,
                title: closeTitle,
                type: 'button',
                onClick: this._onClick
            }
        };
    };
    Tag.prototype.render = function () {
        var _a = this.props, text = _a.text, isCloseable = _a.isCloseable, style = _a.style;
        var _b = this._getProps(), tagProps = _b.tagProps, dotProps = _b.dotProps, closeProps = _b.closeProps;
        return (React.createElement("div", __assign({}, tagProps),
            style === 'Dot' && React.createElement("div", __assign({}, dotProps)),
            text,
            isCloseable && React.createElement("button", __assign({}, closeProps))));
    };
    Tag.defaultProps = {
        tag: null,
        text: '',
        color: 'Grey50',
        customColor: null,
        backgroundColor: null,
        closeTitle: 'close',
        value: '',
        isCloseable: false,
        style: 'Filled',
        truncate: false
    };
    return Tag;
}(React.Component));
exports.default = Tag;
//# sourceMappingURL=Tag.js.map


//////////////////
// WEBPACK FOOTER
// ../player-tag/build/control/Tag.js
// module id = 949
// module chunks = 0